var render, staticRenderFns
import script from "./NewRegistrationsGraph.vue?vue&type=script&lang=js&"
export * from "./NewRegistrationsGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbca836",
  null
  
)

export default component.exports